import _get from 'lodash/get';
import { mergeArraysByKey, post, sortObjectKeys } from '@/lib/utils';

const localState = {
  userPreferences: [],
  sitePreferences: [],
  globalPreferences: [],
};


const localGetters = {
  getPreference: state => preference => {
    const [filterUserPreferences = false] = state.userPreferences.filter((pref) => {
      return pref.preferenceid === preference;
    });
    if (filterUserPreferences) return { preference: filterUserPreferences, level: 'user' };

    const [filterSitePreferences = false] = state.sitePreferences.filter((pref) => {
      return pref.preferenceid === preference;
    });
    if (filterSitePreferences) return { preference: filterSitePreferences, level: 'site' };

    const [filterGlobalPreferences = false] = state.globalPreferences.filter((pref) => {
      return pref.preferenceid === preference;
    });
    if (filterGlobalPreferences) return { preference: filterGlobalPreferences, level: 'global' };

    return { preference: {}, level: null };
  },
};


const localActions = {
  initializePreferences({ commit }, user) {
    commit('set_initial_preferences', user);
  },


  async saveUserPreference({ commit }, payload) {
    const { params, additionalConfig = {} } = payload;
    const { results, errors } = await post('/tg/userpreference/save', params, false, additionalConfig);
    if (results && !errors) commit('update_user_preference', params);
  },


  async deleteUserPreference({ commit, rootGetters }, { preferenceid, silentResponse = false }) {
    const username = rootGetters['auth/username'];
    const params = { username, preferenceid };
    const { results, errors } = await post('/tg/userpreference/delete', params, false, { silentResponse });
    if (results && !errors) commit('delete_user_preference', preferenceid);
  },


  async setupPreferenceSave({ rootGetters }, { preferenceid, preferenceValue, stringify = false, preferenceLevel = 'User' }) {
    if (typeof preferenceValue === 'object') preferenceValue = sortObjectKeys(preferenceValue);
    const username = rootGetters['auth/username'];
    const value = stringify ? JSON.stringify(preferenceValue) : preferenceValue;
    const prefName = `${preferenceLevel}Preference`;
    const saveParams = {
      [prefName]: {
        restricted_attributes: null, // TODO: really check for restricted attributes
        username,
        value,
        preferenceid,
      },
    };
    const copyPreference = rootGetters['preferences/getPreference'](preferenceid);
    const copyPreferenceValue = _get(copyPreference, 'preference.value');
    if (copyPreferenceValue !== undefined && copyPreference.level === preferenceLevel.toLowerCase()) {
      const original = {
        value: !copyPreferenceValue ? null : `${copyPreferenceValue}`,
        username,
        preferenceid,
      };
      saveParams[prefName].original = original;
    }
    return saveParams;
  },
};


const localMutations = {
  update_user_preference(state, { UserPreference }) {
    state.userPreferences = mergeArraysByKey(state.userPreferences, UserPreference, 'preferenceid');
  },


  delete_user_preference(state, preferenceid) {
    const index = state.userPreferences.findIndex(pref => pref.preferenceid === preferenceid);
    state.userPreferences.splice(index, 1);
  },


  set_initial_preferences(state, { preferences, sitepreferences, globalpreferences }) {
    state.userPreferences = preferences;
    state.sitePreferences = sitepreferences;
    state.globalPreferences = globalpreferences;
  },
};


export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
